import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { Select } from 'web-ui-components/lib/atoms/forms';
import withValidation from '../../../containers/withValidation';
import { paymentFrequencyOptions } from '../../../config/paymentFrequencyOptions';

const PaymentFrequency = ({ frequencyLabel, frequency, handleSelectFrequency, errorMessage }) => (
	<Field>
		<FieldHeader
			name="field-payment-frequency"
			titleText={frequencyLabel}
			hasError={!!errorMessage}
			validationMessage={errorMessage}
		/>
		<FieldBody>
			<Select
				id="field-payment-frequency"
				options={paymentFrequencyOptions}
				value={frequency}
				onChange={handleSelectFrequency}
				iconType="ChevronDownSolidSmall"
			/>
		</FieldBody>
	</Field>
);
PaymentFrequency.propTypes = {
	frequencyLabel: PropTypes.string,
	frequency: PropTypes.string,
	handleSelectFrequency: PropTypes.func,
	errorMessage: PropTypes.string,
};

export { PaymentFrequency };
export default withValidation({
	validations: ['required'],
	key: 'frequency',
	message: 'Please select one of the options.',
})(PaymentFrequency);
